import type { ScreenContext } from "../../shell/types";
import { api, el, toast } from "../../ui/dom";
import { pageHead } from "../empty";

// Settings › Plan and billing (brief 1E-12, mockup v62 settings/planbill): Billed to, the business
// FlowCare's invoices are made out to; any live business. Admin; a change is in the history. The
// rest of the mockup's screen (plan, packages, card on file) comes with its own brief. Brief 1E-14:
// a company with one live business doesn't see Billed to; FlowCare bills that business.

interface BilledTo {
  businesses: { id: string; name: string }[];
  billingBusiness: string | null;
}

export async function planBillScreen(host: HTMLElement, ctx: ScreenContext) {
  host.append(pageHead(ctx));
  const res = await api<BilledTo>("GET", "/api/settings/billed-to");
  if (!res.ok) {
    host.append(
      el(
        "p",
        { class: "note", role: "alert" },
        res.body.error ?? "Plan and billing couldn't be loaded.",
      ),
    );
    return;
  }
  if (res.body.businesses.length < 2) return;
  let now = res.body.billingBusiness;
  const input = el(
    "select",
    { id: "billbiz" },
    ...(now ? [] : [el("option", { value: "", selected: true }, "Pick a business")]),
    ...res.body.businesses.map((b) =>
      el("option", { value: b.id, selected: b.id === now }, b.name),
    ),
  );
  input.addEventListener("change", async () => {
    if (!input.value) return;
    input.disabled = true;
    const put = await api<BilledTo>("PUT", "/api/settings/billed-to", { business: input.value });
    input.disabled = false;
    if (!put.ok) {
      input.value = now ?? "";
      return toast("Billed to wasn't changed", put.body.error);
    }
    now = put.body.billingBusiness;
    input.querySelector('option[value=""]')?.remove();
    toast(`FlowCare invoices go to ${res.body.businesses.find((b) => b.id === now)?.name ?? ""}`);
  });
  host.append(
    el(
      "section",
      { class: "card" },
      el(
        "div",
        { class: "field", style: "margin:0;max-width:420px" },
        el("label", { for: "billbiz" }, "Billed to"),
        input,
        el("span", { class: "hint" }, "FlowCare's invoices are made out to this business."),
      ),
    ),
  );
}
